import type { MouseEvent } from 'react';
import type { InsightStatsItem } from 'types/common';
import Styled from './InsightStats.styled';

interface Props {
  insights: InsightStatsItem[];
  onInsightClick: (
    event: MouseEvent<HTMLElement>,
    insightIds: string,
    content?: string | null
  ) => void;
}

function InsightStats({ insights, onInsightClick }: Props) {
  const hasTitle = insights.some((insight) => Boolean(insight.title));
  const hasBody = insights.some((insight) => Boolean(insight.body));
  const hasDescription = insights.some((insight) =>
    Boolean(insight.description)
  );
  const rowCount =
    1 + Number(hasTitle) + Number(hasBody) + Number(hasDescription);

  return (
    <Styled.Items $rowCount={rowCount}>
      {insights.map((insight) => (
        <Styled.Item
          key={insight.insightId}
          $rowCount={rowCount}
          className="insight-stat-item"
          onClick={(event) =>
            onInsightClick(event, insight.insightId, insight.title ?? null)
          }>
          {hasTitle ? <Styled.Title>{insight.title}</Styled.Title> : null}
          {hasBody ? <Styled.Body>{insight.body}</Styled.Body> : null}
          <Styled.Value>{insight.value}</Styled.Value>
          {hasDescription ? (
            <Styled.Description>{insight.description}</Styled.Description>
          ) : null}
        </Styled.Item>
      ))}
    </Styled.Items>
  );
}

export default InsightStats;
